import { useContext, useMemo } from 'react';
import { coerceNumber } from '@visx/scale';
import DataContext from "../../../context/DataContext.js";
import getScaleBandwidth from "../../../utils/getScaleBandwidth.js";
import isValidNumber from "../../../typeguards/isValidNumber.js";
import { jsx as _jsx } from "react/jsx-runtime";
// used for auto-positioning
const minimumLabelDimension = 16;
export default function BaseAnnotation(_ref) {
  let {
    AnnotationComponent,
    children,
    datum,
    dataKey,
    xAccessor: propsXAccessor,
    yAccessor: propsYAccessor,
    dx: propsDx = 0,
    dy: propsDy = 0,
    ...annotationProps
  } = _ref;
  const {
    innerHeight,
    innerWidth,
    margin,
    xScale,
    yScale,
    dataRegistry
  } = useContext(DataContext) || {};
  const xBandWidth = useMemo(() => xScale ? getScaleBandwidth(xScale) : 0, [xScale]);
  const yBandWidth = useMemo(() => yScale ? getScaleBandwidth(yScale) : 0, [yScale]);
  if ((!propsXAccessor || !propsYAccessor) && !dataKey) {
    console.warn('[@visx/xychart/BaseAnnotation]: dataKey or x/yAccessors must be specified.');
    return null;
  }
  const registryEntry = propsXAccessor && propsYAccessor || dataKey == null ? null : dataRegistry?.get(dataKey);
  const xAccessor = propsXAccessor || registryEntry?.xAccessor;
  const yAccessor = propsYAccessor || registryEntry?.yAccessor;
  if (!xScale || !yScale || !innerWidth || !innerHeight || !xAccessor || !yAccessor || !margin) {
    return null;
  }
  const x = (coerceNumber(xScale(xAccessor(datum))) ?? NaN) + xBandWidth / 2;
  const y = (coerceNumber(yScale(yAccessor(datum))) ?? NaN) + yBandWidth / 2;
  const dx = x + propsDx + minimumLabelDimension > margin.left + innerWidth ? -propsDx : propsDx;
  const dy = y + propsDy + minimumLabelDimension > margin.top + innerHeight ? -propsDy : propsDy;
  return isValidNumber(x) && isValidNumber(y) ? /*#__PURE__*/_jsx(AnnotationComponent, {
    width: innerWidth,
    height: innerHeight,
    ...annotationProps,
    x: x,
    y: y,
    dx: dx,
    dy: dy,
    children: children
  }) : null;
}